export default __webpack_public_path__ + "static/media/new-placeholder.296fc672.png";